import { render, staticRenderFns } from "./BilletBox.vue?vue&type=template&id=372b0ff8&scoped=true"
import script from "./BilletBox.vue?vue&type=script&lang=js"
export * from "./BilletBox.vue?vue&type=script&lang=js"
import style0 from "./BilletBox.vue?vue&type=style&index=0&id=372b0ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372b0ff8",
  null
  
)

export default component.exports